import React from 'react';

import FoundationTextbox from './FoundationTextbox';
import FoundationTextboxIconSymbol from './FoundationTextboxIconSymbol';

import type {
    FoundationTextboxProps,
} from './types';


function FoundationSearchTextbox(props: FoundationTextboxProps, ref: React.Ref<HTMLInputElement>): React.ReactElement {
    return (
        <FoundationTextbox
            { ...props }
            ref={ ref }
            symbol={ (<FoundationTextboxIconSymbol icon="search" />) } />
    );
}

export default React.forwardRef(FoundationSearchTextbox);
